var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "product-card-list-provider",
    _vm._b(
      {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({
              productList,
              onItemAdded,
              getAddProductToCartModel,
            }) {
              return [
                _c(
                  "ul",
                  { staticClass: "gfu-grid gfu-grid--gutter" },
                  _vm._l(productList, function (product) {
                    return _c(
                      "li",
                      {
                        key: product.productId,
                        staticClass:
                          "gfu-grid__cell gfu-1of1 gfu-1of2--m gfu-1of3--l",
                      },
                      [
                        _c(
                          "product-card",
                          _vm._b(
                            {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "action",
                                    fn: function () {
                                      return [
                                        _c(
                                          "add-product-to-cart",
                                          _vm._b(
                                            {
                                              on: { "item-added": onItemAdded },
                                            },
                                            "add-product-to-cart",
                                            getAddProductToCartModel(product),
                                            false
                                          )
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            "product-card",
                            product,
                            false
                          )
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            },
          },
        ]),
      },
      "product-card-list-provider",
      _vm.$props,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }